<script setup lang="ts">
withDefaults(defineProps<{
  as?: string
  highlight?: string
  highlightColor?: 'chalk' | 'red' | 'yellow'
  level?: 1 | 2 | 3
}>(), {
  as: undefined,
  highlight: undefined,
  highlightColor: 'yellow',
  level: 1,
})
</script>

<template>
  <component
    :is="as ?? `h${level}`"
    class="font-editorial italic font-black leading-[0.95] tracking-[-0.01em] isolate"
    :class="[
      level === 1 ? 'text-hero' : level === 2 ? 'text-display' : 'text-sticker-lg',
    ]"
  >
    <template v-if="highlight">
      <!--
        Surrounding text wrappers paint above the rotated highlight pill.
        The pill's transform creates its own stacking context (z=0/auto);
        relative + z-10 here lifts the slot text above the rotated edges so
        the yellow rectangle never covers letters of the surrounding words.
      -->
      <span class="relative z-10"><slot/></span>
      <span
        class="inline-block align-baseline font-display not-italic font-normal px-3 py-1 mx-1 rounded-[4px] leading-none"
        :style="{
          background: `var(--color-brand-${highlightColor})`,
          color: highlightColor === 'chalk' ? 'var(--color-brand-ink)' : 'var(--color-brand-ink)',
          textShadow: 'none',
          transform: 'rotate(-1.5deg)',
        }"
      >{{ highlight }}</span>
      <span class="relative z-10"><slot name="after"/></span>
    </template>
    <template v-else>
      <slot/>
    </template>
  </component>
</template>
